import gql from 'graphql-tag';

import FragmentWrapper from 'graphql-client/FragmentWrapper';
import {PipelineStepDataFragment} from 'pipelines/graphql/PipelineStepDataFragment';
import {PipelineStepFragment} from 'pipelines/graphql/PipelineStepFragment';

import {AnalysisViewFragment as AnalysisViewFragmentType} from './__generated/AnalysisViewFragment';

export const ANALYSIS_VIEW_FRAGMENT = gql`
  fragment AnalysisViewFragment on AnalysisViewNode {
    lineage {
      step {
        ...PipelineStepFragment
      }
      stepOutputReference {
        outputStepData {
          ...PipelineStepDataFragment
        }
        rawDataIndex
      }
    }
  }

  ${PipelineStepFragment.fragment}
  ${PipelineStepDataFragment.fragment}
`;

export const AnalysisViewFragment: FragmentWrapper<AnalysisViewFragmentType> = {
  fragment: ANALYSIS_VIEW_FRAGMENT,
  fragmentName: 'AnalysisViewFragment',
};
